/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react'

function loadCalendlyLibary() {
  return new Promise(resolve => {
    const stylesId = 'calendly-styles'
    const scriptId = 'calendly-script'
    const existingStyles = document.getElementById(stylesId)
    const existingScript = document.getElementById(scriptId) && window.Calendly

    if (existingScript) {
      return resolve(true)
    }

    if (!existingStyles) {
      const link = document.createElement('link')
      link.href = `https://assets.calendly.com/assets/external/widget.css`
      link.id = stylesId
      link.rel = 'stylesheet'
      document.head.appendChild(link)
    }

    if (!existingScript) {
      const script = document.createElement('script')
      script.src = `https://assets.calendly.com/assets/external/widget.js`
      script.id = scriptId
      script.defer = true
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(true)
      }
      document.body.appendChild(script)
    }
  })
}

export function useCalendly() {
  const [isLibraryLoaded, setIsLibraryLoaded] = useState(false)

  useEffect(() => {
    let didCancel = false

    loadCalendlyLibary().then(() => {
      if (!didCancel) {
        setIsLibraryLoaded(true)
      }
    })

    return () => {
      didCancel = true
    }
  }, [])

  return isLibraryLoaded ? window.Calendly : null
}
